var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5284 6.66428C14.8328 8.15794 14.6159 9.71081 13.9139 11.0639C13.2119 12.417 12.0672 13.4886 10.6708 14.0998C9.27436 14.7111 7.71058 14.8252 6.24021 14.4231C4.76985 14.021 3.48179 13.1269 2.59083 11.89C1.69987 10.6532 1.25986 9.14822 1.3442 7.62619C1.42853 6.10417 2.03209 4.65705 3.05425 3.52617C4.0764 2.39529 5.45535 1.64901 6.96113 1.41178C8.46692 1.17454 10.0085 1.4607 11.3289 2.22252",
    stroke: "#00A63E",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99805 7.33072L7.99734 9.33001L14.6616 2.66571",
    stroke: "#00A63E",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9943,
    height: 15.9943,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon18);
export default __webpack_public_path__ + "static/media/icon18.a89cc0454d1daa0a82d9a829f2dbb790.svg";
export { ForwardRef as ReactComponent };